// main
export const projectsFeature = 'projectsFeature';
export const releaseGroupsFeature = 'releaseGroupsFeature';
export const continuousMonitoringFeature = 'continuousMonitoringFeature';
export const apiSupportFeature = 'apiSupportFeature';
export const packageIndexFeature = 'packageIndexFeature';
export const issueDashboardFeature = 'issueDashboardFeature';
export const autoIgnoreRulesFeature = 'autoIgnoreRulesFeature';
export const issueFiltersFeature = 'issueFiltersFeature';
export const savedFiltersFeature = 'savedFiltersFeature';
// codeScanning
export const sourceCodeScanningFeature = 'sourceCodeScanningFeature';
export const deepDepDiscoveryFeature = 'deepDepDiscoveryFeature';
export const quickImportGitHubFeature = 'quickImportGitHubFeature';
export const cicdIntegrationFeature = 'cicdIntegrationFeature';
export const branchTagScanningFeature = 'branchTagScanningFeature';
export const containerScanningFeature = 'containerScanningFeature';
export const policyScanDepthLevelsFeature = 'policyScanDepthLevelsFeature';
export const dependencyScanDepthLevelsFeature = 'dependencyScanDepthLevelsFeature';
// security
export const vulnIdentificationFeature = 'vulnIdentificationFeature';
export const vulnManagementFeature = 'vulnManagementFeature';
export const defaultSecurityPoliciesFeature = 'defaultSecurityPoliciesFeature';
export const customizeableSecurityPoliciesFeature = 'customizeableSecurityPoliciesFeature';
export const basicIssueFilterSortFeature = 'basicIssueFilterSortFeature';
export const advancedIssueFilterSortFeature = 'advancedIssueFilterSortFeature';
// compliance
export const licenseIdentificationFeature = 'licenseIdentificationFeature';
export const licensingPolicyManagementFeature = 'licensingPolicyManagementFeature';
export const defaultLicensePoliciesFeature = 'defaultLicensePoliciesFeature';
export const customizeableLicensePoliciesFeature = 'customizeableLicensePoliciesFeature';
// quality
export const packageHealthSignalsFeature = 'packageHealthSignalsFeature';
export const defaultQualityPoliciesFeature = 'defaultQualityPoliciesFeature';
export const customizeableQualityPoliciesFeature = 'customizeableQualityPoliciesFeature';
// sbom
export const sbomGenerationFeature = 'sbomGenerationFeature';
export const sbomImportFeature = 'sbomImportFeature';
export const vexAnnotationsFeature = 'vexAnnotationsFeature';
export const appSbomFeature = 'appSbomFeature';
export const publicSbomFeature = 'publicSbomFeature';
export const privateSbomFeature = 'privateSbomFeature';
// reporting
export const attributionReportFeature = 'attributionReportFeature';
export const auditDueDiligenceReportFeature = 'auditDueDiligenceReportFeature';
export const vulnReportFeature = 'vulnReportFeature';
export const globalBundleFeature = 'globalBundleFeature';
export const issueOverviewFeature = 'issueOverviewFeature';
export const complianceReportFeature = 'complianceReportFeature';
export const licensePackageReportFeature = 'licensePackageReportFeature';
// adminControl
export const auditLogsFeature = 'auditLogsFeature';
export const jiraIntegrationFeature = 'jiraIntegrationFeature';
export const slackIntegrationFeature = 'slackIntegrationFeature';
export const ssoFeature = 'ssoFeature';
export const rbacFeature = 'rbacFeature';
export const teamFeature = 'teamFeature';
// support
export const basicEmailFeature = 'basicEmailFeature';
export const priorityEmailFeature = 'priorityEmailFeature';
export const onboardingAndSupportFeature = 'onboardingAndSupportFeature';
export const slaFeature = 'slaFeature';
// deployments
export const saasDeploymentFeature = 'saasDeploymentFeature';
export const managedSaasDeploymentFeature = 'managedSaasDeploymentFeature';
export const onPremDeploymentFeature = 'onPremDeploymentFeature';

export const mainFeatures = {
  projectsFeature,
  releaseGroupsFeature,
  continuousMonitoringFeature,
  apiSupportFeature,
  packageIndexFeature,
  issueDashboardFeature,
  autoIgnoreRulesFeature,
  issueFiltersFeature,
  savedFiltersFeature,
} as const;
export type MainFeature = keyof typeof mainFeatures;

export const codeScanningFeatures = {
  sourceCodeScanningFeature,
  deepDepDiscoveryFeature,
  quickImportGitHubFeature,
  cicdIntegrationFeature,
  branchTagScanningFeature,
  containerScanningFeature,
  policyScanDepthLevelsFeature,
  dependencyScanDepthLevelsFeature,
} as const;
export type CodeScanningFeature = keyof typeof codeScanningFeatures;

export const securityFeatures = {
  vulnIdentificationFeature,
  vulnManagementFeature,
  defaultSecurityPoliciesFeature,
  customizeableSecurityPoliciesFeature,
  basicIssueFilterSortFeature,
  advancedIssueFilterSortFeature,
} as const;
export type SecurityFeature = keyof typeof securityFeatures;

export const complianceFeatures = {
  licenseIdentificationFeature,
  licensingPolicyManagementFeature,
  defaultLicensePoliciesFeature,
  customizeableLicensePoliciesFeature,
} as const;
export type ComplianceFeature = keyof typeof complianceFeatures;

export const qualityFeatures = {
  packageHealthSignalsFeature,
  defaultQualityPoliciesFeature,
  customizeableQualityPoliciesFeature,
} as const;
export type QualityFeature = keyof typeof qualityFeatures;

export const sbomFeatures = {
  sbomGenerationFeature,
  sbomImportFeature,
  vexAnnotationsFeature,
  appSbomFeature,
  publicSbomFeature,
  privateSbomFeature,
} as const;
export type SbomFeature = keyof typeof sbomFeatures;

export const reportingFeatures = {
  attributionReportFeature,
  auditDueDiligenceReportFeature,
  vulnReportFeature,
  globalBundleFeature,
  issueOverviewFeature,
  complianceReportFeature,
  licensePackageReportFeature,
} as const;
export type ReportingFeature = keyof typeof reportingFeatures;

export const adminControlFeatures = {
  auditLogsFeature,
  jiraIntegrationFeature,
  slackIntegrationFeature,
  ssoFeature,
  rbacFeature,
  teamFeature,
} as const;
export type AdminControlFeature = keyof typeof adminControlFeatures;

export const supportFeatures = {
  basicEmailFeature,
  priorityEmailFeature,
  onboardingAndSupportFeature,
  slaFeature,
} as const;
export type SupportFeature = keyof typeof supportFeatures;

export const deploymentFeatures = {
  saasDeploymentFeature,
  managedSaasDeploymentFeature,
  onPremDeploymentFeature,
} as const;
export type DeploymentFeature = keyof typeof deploymentFeatures;

export type FossaFeature =
  | MainFeature
  | CodeScanningFeature
  | SecurityFeature
  | ComplianceFeature
  | QualityFeature
  | SbomFeature
  | ReportingFeature
  | AdminControlFeature
  | SupportFeature
  | DeploymentFeature;

export const featureGroups = [
  'mainFeatures',
  'codeScanningFeatures',
  'securityFeatures',
  'complianceFeatures',
  'qualityFeatures',
  'sbomFeatures',
  'reportingFeatures',
  'adminControlFeatures',
  'supportFeatures',
  'deploymentFeatures',
] as const;

export type FeatureGroups = typeof featureGroups[number];

export type FeatureDescription = {
  name: string;
  tooltipText?: string;
  isFeatureNamePlural?: boolean;
};

export type FullTierDescription = {
  mainFeatures: { [key in MainFeature]: string | boolean };
  codeScanningFeatures: { [key in CodeScanningFeature]: string | boolean };
  securityFeatures: { [key in SecurityFeature]: string | boolean };
  complianceFeatures: { [key in ComplianceFeature]: string | boolean };
  qualityFeatures: { [key in QualityFeature]: string | boolean };
  sbomFeatures: { [key in SbomFeature]: string | boolean };
  reportingFeatures: { [key in ReportingFeature]: string | boolean };
  adminControlFeatures: { [key in AdminControlFeature]: string | boolean };
  supportFeatures: { [key in SupportFeature]: string | boolean };
  deploymentFeatures: { [key in DeploymentFeature]: string | boolean };
};

export type FullFeatureDescriptions = {
  mainFeatures: { [key in MainFeature]: FeatureDescription };
  codeScanningFeatures: { [key in CodeScanningFeature]: FeatureDescription };
  securityFeatures: { [key in SecurityFeature]: FeatureDescription };
  complianceFeatures: { [key in ComplianceFeature]: FeatureDescription };
  qualityFeatures: { [key in QualityFeature]: FeatureDescription };
  sbomFeatures: { [key in SbomFeature]: FeatureDescription };
  reportingFeatures: { [key in ReportingFeature]: FeatureDescription };
  adminControlFeatures: { [key in AdminControlFeature]: FeatureDescription };
  supportFeatures: { [key in SupportFeature]: FeatureDescription };
  deploymentFeatures: { [key in DeploymentFeature]: FeatureDescription };
};

export const featureDescriptions: FullFeatureDescriptions = {
  mainFeatures: {
    [projectsFeature]: {
      name: 'Projects',
    },
    [releaseGroupsFeature]: {
      name: 'Release Groups',
      tooltipText: 'Bundle multiple projects to track as a group.',
    },
    [continuousMonitoringFeature]: {
      name: 'Continuous Monitoring',
      tooltipText: 'Integrates into your CI/CD pipeline for analysis and scans of your builds.',
    },
    [apiSupportFeature]: {
      name: 'API Support',
      tooltipText: 'Access FOSSA data via the public API.',
    },
    [packageIndexFeature]: {
      name: 'Package Index',
      tooltipText: 'Organization-wide package dashboard for all package versions from scanned projects.',
    },
    [issueDashboardFeature]: {
      name: 'Issue Dashboard',
      tooltipText: 'Organization-wide dashboard to triage issues across projects and teams.',
    },
    [autoIgnoreRulesFeature]: {
      name: 'Ignore Rules',
      tooltipText: 'Create ignore rules for persisting issue triage decisions across projects or package versions.',
    },
    [issueFiltersFeature]: {
      name: 'Issue Filters',
      tooltipText: 'A set of tools for identifying the separating the highest priority issues from the noise.',
    },
    [savedFiltersFeature]: {
      name: 'Saved Filters',
      tooltipText: 'Save your most commonly used filters for ease of access.',
    },
  },
  codeScanningFeatures: {
    [sourceCodeScanningFeature]: {
      name: 'Source Code Scanning',
      tooltipText: 'Scan and detect direct and indirect dependencies in your code.',
    },
    [deepDepDiscoveryFeature]: {
      name: 'Transitive Dependency Discovery',
      tooltipText: 'Identification of dependencies brought into your code via manually added dependencies.',
    },
    [quickImportGitHubFeature]: {
      name: 'Quick Import (GitHub)',
      tooltipText: 'Integrate at the source with GitHub.',
    },
    [cicdIntegrationFeature]: {
      name: 'CI/CD Integration (CLI)',
      tooltipText: 'Integrate within your CI/CD pipeline with the FOSSA CLI.',
    },
    [branchTagScanningFeature]: {
      name: 'Branch/Tag Scanning',
      tooltipText: 'Ability to scan branches or tags in your repositories.',
    },
    [containerScanningFeature]: {
      name: 'Container Scanning',
      tooltipText: 'Scan base container images for vulnerabilities.',
    },
    [policyScanDepthLevelsFeature]: {
      name: 'Policy Scan Depth Levels',
      tooltipText: 'Maximum depth level of your constructed dependency graph used for policy scans.',
    },
    [dependencyScanDepthLevelsFeature]: {
      name: 'Dependency Scan Depth Levels',
      tooltipText:
        'Maximum depth level of your constructed dependency graph for dependencies collected during analysis.',
    },
  },
  securityFeatures: {
    [vulnIdentificationFeature]: {
      name: 'Vulnerability Identification',
      tooltipText: 'Issue scans to identify security issues in your open source dependencies.',
    },
    [vulnManagementFeature]: {
      name: 'Vulnerability Management',
      tooltipText: 'Workflow to understand and remediate security issues.',
    },
    [defaultSecurityPoliciesFeature]: {
      name: 'Default Security Policies',
      tooltipText: 'Preset rules to identify common issues in your code.',
    },
    [customizeableSecurityPoliciesFeature]: {
      name: 'Customizable Security Policies',
      tooltipText: 'Customizable rules to identify issues in your code based on your organizational needs.',
    },
    [basicIssueFilterSortFeature]: {
      name: 'Basic Issue Filter & Sort',
      tooltipText: 'Basic issue filtering and sorting capabilities: Depth, Severity, CWE, Reachability',
    },
    [advancedIssueFilterSortFeature]: {
      name: 'Advanced Issue Filter & Sort',
      tooltipText:
        'Advanced issue filtering and sorting capabilities: EPSS, Upgrade Distance, Ticket status, Exploit Maturity (KEV)',
    },
  },
  complianceFeatures: {
    [licenseIdentificationFeature]: {
      name: 'License Compliance Identification',
      tooltipText: 'Policy scans to identify compliance issues in your open source dependencies.',
    },
    [licensingPolicyManagementFeature]: {
      name: 'License Compliance Management',
      tooltipText: 'Workflow to understand and remediate compliance issues.',
    },
    [defaultLicensePoliciesFeature]: {
      name: 'Default License Policies',
      tooltipText: 'Preset rules to identify common license issues in your code.',
    },
    [customizeableLicensePoliciesFeature]: {
      name: 'Customizable License Policies',
      tooltipText: 'Customizable rules to identify license issues in your code based on your organizational needs.',
    },
  },
  qualityFeatures: {
    [packageHealthSignalsFeature]: {
      name: 'Package Health Signals',
      tooltipText: 'Health signals for packages in your projects.',
    },
    [defaultQualityPoliciesFeature]: {
      name: 'Default Quality Policies',
      tooltipText: 'Preset rules to identify common quality issues in your projects',
    },
    [customizeableQualityPoliciesFeature]: {
      name: 'Customizable Quality Policies',
      tooltipText: 'Customizable rules to identify quality issues in your projects based on your organizational needs.',
    },
  },
  sbomFeatures: {
    [sbomGenerationFeature]: {
      name: 'SBOM Generation (SPDX, CycloneDX)',
      tooltipText: 'Generate an SBOM from a repository scan',
    },
    [sbomImportFeature]: {
      name: 'SBOM Import',
      tooltipText: 'Import SBOMs from your third party suppliers or from other scanning tools',
    },
    [vexAnnotationsFeature]: {
      name: 'Automated VEX Annotations',
      tooltipText: 'Automatically annotate SBOMs with VEX data.',
    },
    [appSbomFeature]: {
      name: 'Application SBOM',
      tooltipText: 'Generate an application-level SBOM, covering multiple repositories and imported SBOMs.',
    },
    [publicSbomFeature]: {
      name: 'Public SBOM Distribution Portal',
      tooltipText: 'Public SBOM Distribution Portal w/ time-based access tokens',
    },
    [privateSbomFeature]: {
      name: 'Private SBOM Distribution Portal',
      tooltipText: 'Private SBOM Distribution Portal w/ time-based access tokens',
    },
  },
  reportingFeatures: {
    [attributionReportFeature]: {
      name: '3rd-Party Attribution Report',
      tooltipText: 'Audit-ready attributions that include raw copyright notices that you can distribute to users.',
    },
    [auditDueDiligenceReportFeature]: {
      name: 'Audit/Due Diligence Report',
      tooltipText: 'Organization-wide report on issues and project changes.',
    },
    [vulnReportFeature]: {
      name: 'Project Vulnerability Reports',
      tooltipText: 'Generate a project report of vulnerabilities found and remediated.',
    },
    [globalBundleFeature]: {
      name: 'Global Component Bundle',
      tooltipText: 'Inventory of all packages across your organization.',
    },
    [issueOverviewFeature]: {
      name: 'Issue Overview',
      tooltipText: 'Issue health report for tracking issue history over time.',
    },
    [complianceReportFeature]: {
      name: 'Project Compliance Report',
      tooltipText: 'Customizable license reports with unlimited detail and depth.',
    },
    [licensePackageReportFeature]: {
      name: 'Organization License & Package Report',
      tooltipText: 'Organization-wide report on licenses and packages.',
    },
  },
  adminControlFeatures: {
    [auditLogsFeature]: {
      name: 'Audit Logs',
      tooltipText: 'Timeline of actions taken by users.',
    },
    [jiraIntegrationFeature]: {
      name: 'Jira Integration',
      tooltipText: 'Access to Jira integration',
    },
    [slackIntegrationFeature]: {
      name: 'Slack Integration',
      tooltipText: 'Access to Slack integration',
    },
    [teamFeature]: {
      name: 'Teams',
      tooltipText: 'Add users to teams.',
      isFeatureNamePlural: true,
    },
    [ssoFeature]: {
      name: 'Single Sign-On (SSO)',
      tooltipText: 'Access to SSO services such as Google, GitHub, etc...',
    },
    [rbacFeature]: {
      name: 'Role-Based Access Control (RBAC)',
      tooltipText: 'Control over roles and permissions for all organizational users.',
    },
  },
  supportFeatures: {
    [basicEmailFeature]: {
      name: 'Basic Email Support',
      tooltipText: 'Round-robin support via support@fossa.com',
    },
    [priorityEmailFeature]: {
      name: 'Priority Email Support',
      tooltipText:
        'Dedicated support engineer* & priority handling. *Dedicated engineer provided at FOSSA\'s discretion',
    },
    [onboardingAndSupportFeature]: {
      name: 'Customer Success Manager & Engineer',
      tooltipText:
        'Includes guided onboarding, continuous enablement & ongoing goals, success mapping, and dedicated Slack channel',
    },
    [slaFeature]: {
      name: 'Service Level Agreements (SLAs)',
      tooltipText: 'SLAs for support and escalation response times.',
    },
  },
  deploymentFeatures: {
    [saasDeploymentFeature]: {
      name: 'SaaS Deployment (Multi-tenant cloud)',
      tooltipText: 'FOSSA hosted deployment with shared resources.',
    },
    [managedSaasDeploymentFeature]: {
      name: 'Managed SaaS Deployment',
      tooltipText: 'FOSSA hosted deployment, single-tenant, with dedicated resources.',
    },
    [onPremDeploymentFeature]: {
      name: 'On-Premises Deployment',
      tooltipText: 'Optionally deploy FOSSA on your own infrastructure.',
    },
  },
};

export const getFeatureDetails = (feature?: FossaFeature): FeatureDescription | null => {
  if (!feature) {
    return null;
  }

  const descriptionGroupKeys = Object.keys(featureDescriptions);
  const featureGroup = descriptionGroupKeys.find((group) =>
    Object.keys(
      featureDescriptions[group as keyof FullFeatureDescriptions],
    ).includes(feature),
  );

  // @ts-expect-error We know the typings are correct because of how we generate
  return featureGroup ? featureDescriptions[featureGroup][feature] : null;
};
